/**
 * Conversion des degrés en radian
 * @param deg valeur en degré
 * @returns {number} valeur en radian
 */
export const deg2rad = (deg) => {
  return deg * (Math.PI/180)
}

/**
 * Retourne la distance en kilomètre entre 2 positions GPS
 * Si une des 2 positions n'est pas renseignée, retourne -1
 *
 * @param origine objet contenant les propriétés latitude et longitude
 * @param destination objet contenant les propriétés latitude et longitude
 * @returns {number} distance en kilomètre
 */
export const distanceEnKm = (origine, destination) => {
  // console.log(`[GEO] Origine ${JSON.stringify(origine)}`);
  // console.log(`[GEO] Destination ${JSON.stringify(destination)}`);
  if (!origine || !origine.latitude || !origine.longitude
  ) {
    // console.log(`[GEO] Position de l'origine inconnue`);
    return -1
  }
  if (!destination || !destination.latitude || !destination.longitude
  ) {
    // console.log(`[GEO] Position de la destination inconnue`);
    return -1
  }
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(origine.latitude-destination.latitude);  // deg2rad below
  // console.log(`[Position] dLat : ${dLat}`);
  var dLon = deg2rad(origine.longitude-destination.longitude);
  // console.log(`[Position] dLon : ${dLon}`);
  var a =
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(origine.latitude)) * Math.cos(deg2rad(destination.latitude)) *
    Math.sin(dLon/2) * Math.sin(dLon/2)
  ;
  // console.log(`[Position] a : ${a}`);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  // console.log(`[Position] a : ${c}`);
  var d = Math.round(R * c * 100) / 100; // Distance arrondie en km
  // console.log(`[Position] a : ${d}`);
  // console.log(`[GEO] Distance = ${d}`);
  return d;
}

